import _sfc_main from "./BuyBoxAlertMessage2.mjs";
/* empty css                     */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxAlertMessage = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6e8b2c57"]]);
export {
  BuyBoxAlertMessage as default
};
//# sourceMappingURL=BuyBoxAlertMessage.mjs.map
